import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as CloseIcon } from '@assets/icons/close.svg';

import AddColor from '@components/moodboard/colors/AddColor';
import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

const Colors = ({ moodboardId, colorResponseList }) => {
	const [isAddColor, setIsAddColor] = useState(false);
	const { colorLoader } = useSelector((store) => store.moodboardStore);
	const colorRef = useRef(null);
	const dispatch = useDispatch();

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleClickOutside = (e) => {
		if (colorRef.current && !colorRef.current.contains(e.target)) {
			setIsAddColor(false);
		}
	};

	const onAddColor = () => {
		setIsAddColor(true);
	};
	const onCloseColor = () => {
		setIsAddColor(false);
	};

	const onSubmitColor = async (color) => {
		dispatch(openLoader());
		const body = {
			colorType: 'SOLID',
			representedBy: 'PANTONE_OR_HEX_CODE',
			pantoneColorId: color.id
		};
		await ApiClient.POST('moodboardAction', body, `${moodboardId}/add-color`)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					dispatch({
						type: Types.ADD_COLOR_TO_MOODBOARD,
						payload: data.payload
					});
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onRemoveColor = async (colorId) => {
		dispatch(openLoader());
		await ApiClient.DELETE('moodboardAction', {}, `${moodboardId}/color/${colorId}`)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					dispatch({
						type: Types.REMOVE_COLOR_FROM_MOODBOARD,
						payload: colorId
					});
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	return (
		<>
			{colorLoader ? (
				<div className="mb-5">
					<p className="semibold-14 mb-2">Color</p>
					<div className="moodboard-color-container d-flex justify-content-center">
						{/* <span>Loading...</span> */}
						<img src={`${process.env.PUBLIC_URL}/images/loader.svg`} alt="" />
					</div>
				</div>
			) : (
				<>
					<p className="semibold-14 mb-2">Color</p>
					<div className="moodboard-color-container">
						<div className="color-single-item" onClick={() => onAddColor()}>
							<div className="add-color">
								<span>+</span>
							</div>
						</div>
						{isAddColor && (
							<div className="position-absolute" ref={colorRef}>
								<AddColor
									selectedColors={colorResponseList}
									onCloseColor={onCloseColor}
									onSubmitColor={onSubmitColor}
								/>
							</div>
						)}
						{colorResponseList?.map((item) => (
							<div className="color-single-item" key={item.id}>
								<div className="color-view" style={{ background: item.hexCode }}>
									<span className="close" onClick={() => onRemoveColor(item.id)}>
										<CloseIcon />
									</span>
								</div>
								<div className="color-info">
									<div className="color-code">{item?.code}</div>
									<div className="color-name">{item?.name}</div>
								</div>
							</div>
						))}
					</div>
				</>
			)}
		</>
	);
};

export default Colors;
